const messages = {
  export: 'Export',
  exportData: 'Export Data',
  failedExport: 'Your export failed to download',
  downloadCompleted: 'Your download is now being completed.',
  selectOne: 'Select one',
  selectIntegrationType: 'Select a JOOR integration type',
  basicExport: 'Basic Export',
  exportOrders: 'Export Orders',
  markExported: 'Mark exported orders',
  excludePreviouslyExported: 'Exclude previously exported orders',
  integrationOption: 'JOOR integration option',
  exportType: 'Select a JOOR integration type',
  excludeExported: 'Exclude previously exported orders',
  selectStatus: 'Select',
  selectOrderStatus: 'Select order status',
  selectStatuses: 'Select statuses',
  selectDateType: 'Select a type of date',
  addDateRange: 'Add date range',
  addDate: 'Add date',
  statusNotes: 'Notes',
  statusPending: 'Pending',
  statusApproved: 'Approved',
  statusShipped: 'Shipped',
  statusCancelled: 'Cancelled',
}

export default messages
